import { render, staticRenderFns } from "./ItemApply.vue?vue&type=template&id=045203e0&scoped=true&"
import script from "./ItemApply.vue?vue&type=script&lang=js&"
export * from "./ItemApply.vue?vue&type=script&lang=js&"
import style0 from "./ItemApply.vue?vue&type=style&index=0&id=045203e0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "045203e0",
  null
  
)

export default component.exports